export const categories = [
  { slug: "all", name: "全部", icon: "ri-grid-fill" },
  { slug: "movie", name: "电影", icon: "ri-film-line" },
  { slug: "tv", name: "电视剧", icon: "ri-tv-line" },
  { slug: "variety", name: "综艺", icon: "ri-emotion-laugh-line" },
  { slug: "anime", name: "动漫", icon: "ri-rocket-line" },
  { slug: "documentary", name: "纪录片", icon: "ri-global-line" },
  { slug: "short", name: "短视频", icon: "ri-vidicon-line" },
];

export const categoryMap: Record<string, string> = {
  all: "全部",
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
  anime: "动漫",
  documentary: "纪录片",
  short: "短视频",
};